// extracted by mini-css-extract-plugin
export var deleteModal = "_go-0";